import {
  Component,
  Inject,
  OnInit,
  TemplateRef,
  OnDestroy,
  Input,
  NgZone,
  Output,
  EventEmitter,
  AfterContentInit
} from "@angular/core";
import { BsModalService, BsModalRef } from "ngx-bootstrap";
import { Subscription } from "rxjs";
import {
  ProgramId,
  ProgramDeliveryInformationDto,
  DeliveryLocationLookupDto,
  ProgramShippingLocationDto
} from "../../../client-core/dtos/programs.model";
import { ProgramService } from "../../../client-core/services/program.service";
import { ActivatedRoute, Router } from "@angular/router";
import { NotificationService } from "../../../shared/utils/notification.service";
import { DeliveryLocationModalComponent } from "./create/delivery-location.component";
import { ValidationMessage } from "../../../validation";
import { Observable } from "rxjs/Observable";
import { ApiResponse } from "../../../client-core/api-response-models";
import * as moment from "moment";
import { LayoutService } from "app/shared/layout/layout.service";
import { ImportModalComponent } from "app/+tactic-catalog/finalize/import/import.modal.component";

const $ = jQuery;
@Component({
  selector: "tactic-catalog-finalize-delivery-information",
  templateUrl: "./delivery-information.component.html",
  styleUrls: ["./delivery-information.scss"]
})
export class DeliveryInformationFinalizeComponent implements OnInit, OnDestroy {
  @Input() programId?: number;
  @Input() selectedRetailerId: number;
  @Input() canEdit: boolean;
  @Input() changeReason: number;
  checkDate: boolean;
  @Input() onlyHaveDownloadMethods: boolean;
  @Output() typeSelected = new EventEmitter<string>();
  @Input() fromCampaign = false;
  @Input() contactType = "";
  @Input() deliveryLocationId: number;
  @Input() hideLocationButtons: boolean;
  @Input() selectedUnits: string;
  @Input() contactTypeSecondaryType: string;
  @Input() openSearch: string;
  @Input() suppressEmailContact: number;
  @Input() generateEmailReadyCopy: number;
  processing: boolean;

  programDeliveryInformationDto: ProgramDeliveryInformationDto;
  oldProgramDeliveryInformationDto: ProgramDeliveryInformationDto;

  programDeliveryInformationResponse: ApiResponse<
    ProgramDeliveryInformationDto
  >;

  itemObjectsLeft: ProgramShippingLocationDto[] = [];

  submitting: boolean;
  ready: boolean;
  addressIsValid: boolean;
  validated: boolean;
  minDate: Date = moment()
    .add("days", 1)
    .toDate();

  public validationMessages: ValidationMessage;
  createPlanModal: BsModalRef;
  private createPlanModalConfig = {
    animated: true,
    keyboard: false,
    backdrop: true,
    ignoreBackdropClick: true,
    class: "modal-lg"
  };

  deliveryLocationAddedSubscription: Subscription;

  validatorOptions = {
    //container: '#messages',
    message: "Field is invalid",
    feedbackIcons: {
      valid: "fa fa-check",
      invalid: "fa fa-times",
      validating: "fa fa-refresh"
    },
    fields: {
      // deliveryDate: {
      //     validators: {
      //         date: {
      //             format: "MM/DD/YYYY",
      //             message: "Invalid date format"
      //         }
      //     }
      // }
    }
  };
  distributionDto: any;
  locations: any = [];
  programUpdatedSubscription: Subscription;
  accountLocationId: number;
  searchTerm: string;
  noDataFound: any;
  loading: any;
  currentPage: number;
  distributionPage: number = 1;
  showLoadMore = false;

  onAfterValidate(isValid: boolean): void {
    console.log(">>IsValid", isValid);
    // this.validated = true;
    // if (!isValid || !this.isDeliveryAddressValid())
    //     return;

    if (!isValid) {
      return;
    }

    this.submitting = false;
    this.saveDeliveryInformation();
  }

  moveToSelected(item: ProgramShippingLocationDto) {
    item.markedForDeletion = false;
    this.itemObjectsLeft = [
      ...this.itemObjectsLeft.filter(
        my => my.deliveryLocationId != item.deliveryLocationId
      )
    ];

    console.log(this.itemObjectsLeft);

    var index = this.programDeliveryInformationDto.programShippingLocation.findIndex(
      my => {
        return my.deliveryLocationId == item.deliveryLocationId;
      }
    );

    if (index == -1) {
      this.programDeliveryInformationDto.programShippingLocation.push(item);
      this.programDeliveryInformationDto.programShippingLocation = [
        ...this.programDeliveryInformationDto.programShippingLocation
      ];
    } else {
      this.programDeliveryInformationDto.programShippingLocation[
        index
      ].markedForDeletion = false;
    }

    this.saveDeliveryInformation();
  }

  moveToUnselected(item: ProgramShippingLocationDto) {
    item.markedForDeletion = true;
    this.programDeliveryInformationDto.programShippingLocation = [
      ...this.programDeliveryInformationDto.programShippingLocation
    ];

    var index = this.itemObjectsLeft.findIndex(my => {
      return my.deliveryLocationId == item.deliveryLocationId;
    });

    if (index == -1) {
      this.itemObjectsLeft.push(item);
      this.itemObjectsLeft = [...this.itemObjectsLeft];
    }

    this.saveDeliveryInformation();
  }

  constructor(
    private programService: ProgramService,
    private ngZone: NgZone,
    private modalService: BsModalService,
    private layoutService: LayoutService,
    private router: Router
  ) {
    this.programDeliveryInformationDto = new ProgramDeliveryInformationDto();
  }

  ngOnInit() {
    this.deliveryLocationAddedSubscription = this.programService.deliveryLocationAdded.subscribe(
      (id: ProgramId) => {
        this.loadDeliveryLocationLookup();
        this.loadProgramDeliveryInformation();
        this.getDistribution();
      }
    );

    this.deliveryLocationAddedSubscription = this.programService.deliveryLocationSaved.subscribe(
      (id: ProgramId) => {
        this.loadDeliveryLocationLookup();
        this.loadProgramDeliveryInformation();
        this.getDistribution();
      }
    );

    this.programUpdatedSubscription = this.programService.programUpdated.subscribe(
      (id: ProgramId) => {
        this.loadDeliveryLocationLookup();
        this.loadProgramDeliveryInformation();
        this.getDistribution();
      }
    );

    this.loadProgramDeliveryInformation();
    this.loadDeliveryLocationLookup();
  }



  ngOnDestroy() {
    if (this.deliveryLocationAddedSubscription)
      this.deliveryLocationAddedSubscription.unsubscribe();

    if (this.programUpdatedSubscription)
      this.programUpdatedSubscription.unsubscribe();
  }

  getDistribution(page?) {
      this.programService.getDistributionLocation(this.programId, this.searchTerm, this.distributionPage).subscribe(response => {
      this.distributionDto = response.data;
      if (response.data.locations && response.data.locations.length >= 20) {
        this.showLoadMore = true;
      } else {
        this.showLoadMore = false;
      }
      this.getLocations();
    });
  }

  loadMoreDistribution() {
    this.distributionPage += 1;
    this.getDistribution();
  }

  searchDistributionTimeout = null;
  searchDistribution() {
    if (this.searchDistributionTimeout) {
      clearTimeout(this.searchDistributionTimeout)
    }
    this.searchDistributionTimeout = setTimeout(() => {
      this.getDistribution();
    }, 1000);
  }

  onScrollingFinished() {
    alert('finished')
  }

  loadProgramDeliveryInformation(): void {
    console.log(">>loadProgramDeliveryInformation", this.programId);

    if (!this.programId) {
      this.ready = true;
      return;
    }

    this.programService.getProgramDeliveryInformation(this.programId).subscribe(
      res => {
        if (!res.hasError) {
          this.programDeliveryInformationResponse = res;
          console.log(`this.programDeliveryInformationResponse`, this.programDeliveryInformationResponse)
          this.programDeliveryInformationDto = ProgramDeliveryInformationDto.fixDates(
            res.data
          );
          this.getDistribution();

          // tslint:disable-next-line:max-line-length
          Object.assign(this.oldProgramDeliveryInformationDto || {}, {}, this.oldProgramDeliveryInformationDto || {});
          this.ready = true;
          console.log(
            "oldProgramDeliveryInformationDto",
            this.oldProgramDeliveryInformationDto
          );

          console.log(
            "programDeliveryInformationDto",
            this.programDeliveryInformationDto
          );
        } else {
          this.validationMessages = new ValidationMessage(
            res.error,
            true,
            "Program delivery information could not be retrieved"
          );
        }
      },
      (err: any) => {
        this.validationMessages = new ValidationMessage(
          null,
          true,
          "Unexpected error occured"
        );
      },
      () => { }
    );
  }

  loadDeliveryLocationLookup(): void {
    this.programService.getDeliveryLocationLookup(
      this.programId,
      this.contactType,
      this.selectedRetailerId,
      this.accountLocationId,
      this.contactTypeSecondaryType,
      this.openSearch,
      this.suppressEmailContact,
      this.generateEmailReadyCopy,
      this.selectedUnits
    ).subscribe(
      res => {
        if (!res.hasError) {
          console.log(res.data);
          let data = res.data.items.map((value, index, source) => {
            return ProgramShippingLocationDto.createFrom(
              value,
              new ProgramId(this.programId)
            );
          });

          console.log("loadDeliveryLocation result", data);

          let filteredDeliveryLocationLookup = data.filter(
            (value, index, source) => {
              let idx = this.programDeliveryInformationDto.programShippingLocation.findIndex(
                programShippingLocation => {
                  return programShippingLocation.id == value.id;
                }
              );

              return idx == -1;
            }
          );

          this.itemObjectsLeft = [...filteredDeliveryLocationLookup];
          this.ready = true;
        } else {
          this.validationMessages = new ValidationMessage(
            res.error,
            true,
            "Delivery locations could not be retrieved"
          );
        }
      },
      (err: any) => {
        this.validationMessages = new ValidationMessage(
          null,
          true,
          "Unexpected error occured"
        );
      },
      () => { }
    );
  }

  showAddLocation(): void {
    console.log(">>showAddLocation", this.programId);
    this.programService.showAddWithDeliveryInfoLocationInfo.next({
      deliveryDate: this.programDeliveryInformationDto.deliveryDate,
      deliveryNotes: this.programDeliveryInformationDto.deliveryNotes,
      programId: this.programId
    });
  }

  shouldSaveInfo() {
    if (this.programDeliveryInformationDto.deliveryDate != this.oldProgramDeliveryInformationDto.deliveryDate) {
      return true;
    }

    if (this.programDeliveryInformationDto.deliveryNotes != this.oldProgramDeliveryInformationDto.deliveryNotes) {
      return true;
    }
    return false;
  }

  saveDeliveryInformation() {
    return new Promise((resolve, reject) => {
      this.submitting = true;
      this.validated = false;

      if (!this.validateFields() && !this.onlyHaveDownloadMethods) {
        this.validated = true;
        this.submitting = false;
        resolve(false);
        return false;
      }

      let observe: Observable<ApiResponse<number>>;
      this.programDeliveryInformationResponse.data = this.programDeliveryInformationDto;
      if (!this.programDeliveryInformationResponse.data.deliveryDate) {
        this.programDeliveryInformationResponse.data.deliveryDate = moment().add(1, 'days').toDate();
      }
      observe = this.programService.saveDeliveryInformation(
        this.programId,
        this.programDeliveryInformationResponse
      );
      observe.subscribe(
        res => {
          if (!res.hasError) {
            let msg: string = "Delivery Information Saved";
            this.validationMessages = new ValidationMessage(
              null,
              true,
              msg
            ).isSuccess();
            this.programService.deliveryLocationSaved.next();
            resolve(true);
          } else {
            this.validationMessages = new ValidationMessage(
              res.error,
              true,
              "Delivery Information could not be saved"
            );
            resolve(false);
          }
          this.submitting = false;
        },
        (err: any) => {
          this.submitting = false;
          this.validationMessages = new ValidationMessage(
            null,
            true,
            "Unexpected error occured"
          );
          resolve(false)
        },
        () => {
          this.submitting = false;
        }
      );
    });
  }

  isDeliveryAddressValid() {
    if (!this.programDeliveryInformationDto.programShippingLocation) {
      return false;
    }

    const validAddresses = this.programDeliveryInformationDto.programShippingLocation.filter(
      a => !a.markedForDeletion
    ).length;
    return validAddresses > 0;
  }

  showDeliveryAddressErroMessages() {
    return !this.isDeliveryAddressValid() && this.validated;
  }

  canSaveDeliveryInformation() {
    return this.isDeliveryAddressValid() && this.isDeliveryDateValid();
  }

  isDeliveryDateValid() {
    return (
      this.programDeliveryInformationDto.deliveryDate != null &&
      this.isFutureDate()
    );
  }

  isFutureDate() {
    if (!this.canEdit) {
      return true;
    }
    if (this.onlyHaveDownloadMethods) {
      return true;
    }
    if (
      !this.programDeliveryInformationDto ||
      !this.programDeliveryInformationDto.deliveryDate
    ) {
      return false;
    }

    const minDate = moment(this.minDate.toISOString());
    const choosedDate = moment(
      this.programDeliveryInformationDto.deliveryDate.toISOString()
    );
    return moment(choosedDate.format("MM/DD/YYYY")).isSameOrAfter(
      minDate.format("MM/DD/YYYY")
    );
  }

  validateFields(): boolean {
    if ((!this.isDeliveryAddressValid() || !this.isDeliveryDateValid()) && !this.onlyHaveDownloadMethods) {
      this.validationMessages = new ValidationMessage(
        null,
        true,
        "Delivery Information could not be saved"
      );
      return false;
    }
    return true;
  }

  showAddressPlaceholder() {
    if (!this.programDeliveryInformationDto.programShippingLocation) {
      return true;
    }

    return (
      this.programDeliveryInformationDto.programShippingLocation.filter(
        a => !a.markedForDeletion
      ).length === 0
    );
  }

  importShippingLocations(): void {
    const initialState = {
      programId: this.programId,
      deliveryDate: this.programDeliveryInformationDto.deliveryDate.toISOString(),
      deliveryNotes: this.programDeliveryInformationDto.deliveryNotes
    };
    // tslint:disable-next-line:max-line-length
    this.createPlanModal = this.modalService.show(
      ImportModalComponent,
      Object.assign({}, this.createPlanModalConfig, { initialState })
    );
  }

  downloadTemplate(): void {
    this.programService.getTemplate();
  }

  showDeliveryInformation(type: string) {
    if (this.fromCampaign) {
      this.typeSelected.emit(type);
      return;
    }

    this.layoutService.showDeliveryInformation.next({
      programId: this.programId,
      type, canEdit: this.canEdit,
      onlyHaveDownloadMethods: this.onlyHaveDownloadMethods,
      changeReason: this.changeReason
    });
  }

  getLocations() {
    const locations = this.distributionPage > 1 ? this.locations : [];
    if (this.distributionDto && this.distributionDto.locations) {
      console.log('this.distributionDto: ', this.distributionDto)
      this.distributionDto.locations.forEach(location => {
        let tacticQuantity = 0;
        if (this.distributionDto.tactics && this.distributionDto.tactics) {
          this.distributionDto.tactics.forEach(tactic => {
            if (tactic.locations && tactic.locations) {
              const l = tactic.locations.find(tl => tl.id == location.id);
              if (l) {
                tacticQuantity += l.distributionQuantity;
              }
            }
          });
        }
        locations.push({
          ...location,
          items: tacticQuantity
        });
      });
    }
    this.locations = locations;
  }

  openDistribution(id) {
    this.layoutService.showDeliveryDistributionInformation.next({
      programId: this.programId,
      shippingId: id
    });
  }

  hasNonDistributedLocations() {
    // tslint:disable-next-line:max-line-length
    if (!this.distributionDto || !this.distributionDto.locations || this.distributionDto.locations.filter(d => d.distributed).length === 0) {
      return false;
    }
    console.log('this.distributionDto.locations', this.distributionDto.locations as any);
    // tslint:disable-next-line:max-line-length
    return this.distributionDto && this.distributionDto.locations && this.distributionDto.locations.filter(l => !l.distributed).length > 0;
  }

  navigteToDistribution() {
    this.router.navigateByUrl(`/tactic-catalog/${this.programId}/finalize/distribution`)
  }

  async processProof(location) {
    this.processing = true;
    await this.programService.programApplyProductionProofCustomizations(this.programId, location.id);
    this.programService.getConcatonate(this.programId, location.id, 1).subscribe(res => {
      delete res.hasError;
      delete res.error;
      this.programService.putConcatonate(res).subscribe(concatonateres => {
        this.programService.getProofUrl(this.programId, location.id).subscribe(pr => {
          if (pr.data.url) {
            window.open(pr.data.url, "_blank");
          } else {
            this.validationMessages = new ValidationMessage(
              null,
              true,
              "There was an error generating the URL"
            );
          }
          this.processing = false;
        });
      }, error => {
          this.processing = false;
      });
  });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/delivery-information/delivery-information.component.ts